// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.volumediscounts.new', {
        url:'/new',
        views: {"productView@product": {
            templateUrl: 'main/product/volumediscounts/volumediscount/volumediscount.tpl.html',
            controller: 'VolumeDiscountController as vm'
        }},
        resolve: {
            volumeDiscount: function() { return {}; },
            quantityGroups: quantityGroupsResolver,
            isNewVolumeDiscount: function() { return true; }
        }
    });

    $stateProvider.state('product.volumediscounts.volumediscount', {
        url:'/{volumeDiscountId}',
        views: {"productView@product": {
            templateUrl: 'main/product/volumediscounts/volumediscount/volumediscount.tpl.html',
            controller: 'VolumeDiscountController as vm'
        }},
        resolve: {
            volumeDiscount: volumeDiscountResolver,
            quantityGroups: quantityGroupsResolver,
            isNewVolumeDiscount: function() { return false; }
        }
    });
}

// @ngInject
function volumeDiscountResolver($stateParams, VolumeDiscountsApiService) {
    return VolumeDiscountsApiService.getVolumeDiscount($stateParams.volumeDiscountId);
}

// @ngInject
function quantityGroupsResolver(VolumeDiscountsApiService) {
    return VolumeDiscountsApiService.getQuantityGroups();
}

// @ngInject
function VolumeDiscountController($state, volumeDiscount, loadSpinnerService, VolumeDiscountsApiService, isNewVolumeDiscount, quantityGroups) {
    var vm = this;

    var volumeDiscountCopy = {};

    vm.volumeDiscount = volumeDiscount;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactVolumeDiscountView') === 'true';
    vm.reactVolumeDiscountId = isNewVolumeDiscount ? null : (volumeDiscount && volumeDiscount.id != null ? volumeDiscount.id : null);

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveVolumeDiscount = saveVolumeDiscount;

    vm.isNewVolumeDiscount = isNewVolumeDiscount;
    vm.isEditing = vm.isNewVolumeDiscount;

    vm.isAllInformationValid = isAllInformationValid;
    vm.addLimit = addLimit;
    vm.removeLimit = removeLimit;
    vm.clearLimits = clearLimits;
    vm.quantityGroups = quantityGroups;

    activate();

    function activate() {
        prepareData();

        if (vm.isNewVolumeDiscount) {
            vm.volumeDiscount = {limits:[], quantityGroup: {}};
        }
        vm.newLimit = getNewRowDefaults();
    }

    function clearLimits() {
        vm.volumeDiscount.limits = [];
        vm.newLimit = getNewRowDefaults();
    }

    function removeLimit(limit) {
        _.remove(vm.volumeDiscount.limits, limit);
    }

    function addLimit(limit) {

        var newLimit = { minimumQuantity: Number(limit.minimumQuantity), discountPercent: Number(limit.discountPercent)};

        vm.volumeDiscount.limits.push(newLimit);
        vm.newLimit = getNewRowDefaults();
    }

    function getNewRowDefaults() {

        return {minimumQuantity: 0, discountPercent: 0};

        /*
        var limits = _.orderBy(vm.volumeDiscount.limits,'minimumQuantity');
        var minimumQuantity = _.max(_.map(limits,'minimumQuantity'));
        var discountPercent = _.max(_.map(limits,'discountPercent'));

        // addera skillnaden med det näst sista
        if (limits.length > 1)  {
            minimumQuantity += minimumQuantity - limits[limits.length - 2].minimumQuantity;
            discountPercent += discountPercent - limits[limits.length - 2].discountPercent;
        }
        if (limits.length === 1)  {
            minimumQuantity += minimumQuantity;
            discountPercent += discountPercent;
        }
        return {minimumQuantity: Math.round(minimumQuantity * 100) / 100, discountPercent: Math.round(discountPercent * 100) / 100};
        */
    }

    function enableEditing() {
        volumeDiscountCopy = angular.copy(vm.volumeDiscount);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.volumeDiscount = volumeDiscountCopy;
        vm.isEditing = false;
    }

    function saveVolumeDiscount() {
        if (vm.isNewVolumeDiscount) {
            saveNewVolumeDiscount();
        } else {
            updateVolumeDiscount();
        }
    }

    function saveNewVolumeDiscount() {
        loadSpinnerService.start('mainSpinner');
        VolumeDiscountsApiService.createVolumeDiscount(vm.volumeDiscount).then(function(response) {
            vm.volumeDiscount = response;
            prepareData();
            vm.isNewVolumeDiscount = false;
            vm.isEditing = false;
            $state.go('product.volumediscounts.volumediscount', {volumeDiscountId: response.id});
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateVolumeDiscount() {
        loadSpinnerService.start('mainSpinner');
        VolumeDiscountsApiService.updateVolumeDiscount(vm.volumeDiscount).then(function(response) {
            vm.volumeDiscount = response;
            prepareData();
            vm.isEditing = false;
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.volumeDiscount === undefined) {
            return;
        }
    }

    function isAllInformationValid() {
        return !vm.isNewVolumeDiscount ||
            (isQuantityGroupValid());
    }

    function isQuantityGroupValid() {
        if (!vm.volumeDiscount.quantityGroup) {
            return false;
        }
        if (!vm.volumeDiscount.quantityGroup.id) {
            return false;
        }
        return true;
    }

}

angular
    .module('volumediscounts.volumediscount', [])
    .config(stateConfig)
    .controller('VolumeDiscountController', VolumeDiscountController);
